import React, { useEffect, useState } from "react";

import Section1 from "../includes/AboutUs/Section1";
import Section2 from "../includes/AboutUs/Section2";
import Section3 from "../includes/AboutUs/Section3";
import Section4 from "../includes/AboutUs/Section4";


// form from homepage

import Section9 from "../includes/Home/Section9";

// import { Helmet } from "react-helmet";
import { Helmet } from "react-helmet-async";

const AboutUs = ({ devUrl }) => {
  // const schemaMarkup = {
  //   "@context": "https://schema.org",
  //   "@type": "WebPage",
  //   mainEntityOfPage: {
  //     "@type": "WebPage",
  //     "@id": "exddigital.com",
  //   },
  //   headline: "ExD Digital - About Us",
  //   image: "https://www.exddigital.com/images/about-us/main-banner.jpg",
  //   author: {
  //     "@type": "Organization",
  //     name: "ExD Digital - About Us",
  //     url: "https://www.exddigital.com/about-us",
  //   },
  //   publisher: {
  //     "@type": "Organization",
  //     name: "ExD Digital",
  //     logo: {
  //       "@type": "ImageObject",
  //       url: "https://www.exddigital.com/images/exd_digital.png",
  //     },
  //   },
  //   datePublished: "2023-08-02",
  //   dateModified: "2023-08-03",
  // };

  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    mainEntityOfPage: {
      "@type": "WebPage",
      // ✅ Fixed — full URL with https://www.
      "@id": "https://www.exddigital.com/about-us",
    },
    // ✅ Fixed — clean name
    headline: "About ExD Digital — Our Story, Mission & Team",
    description: "Learn about ExD Digital, our mission to deliver world-class AI, web and software development services, and the team behind our success.",
    image: "https://www.exddigital.com/images/exd_digital.webp",
    author: {
      "@type": "Organization",
      // ✅ Fixed — clean name
      name: "ExD Digital",
      url: "https://www.exddigital.com",
    },
    publisher: {
      "@type": "Organization",
      name: "ExD Digital",
      logo: {
        "@type": "ImageObject",
        // ✅ Fixed — use .webp
        url: "https://www.exddigital.com/images/exd_digital.webp",
      },
    },
    datePublished: "2023-08-02",
    dateModified: "2026-04-20",
  };


    const [currentColor, setCurrentColor] = useState("black");
  
    useEffect(() => {

      const handle_Scroll = () => {
        const panels = document.querySelectorAll(".panel");
        const scroll = window.scrollY + window.innerHeight / 2;
  
        panels.forEach((panel) => {
          if (
            panel.offsetTop <= scroll &&
            panel.offsetTop + panel.offsetHeight > scroll
          ) {
            const newColor = panel.dataset.color;
            setCurrentColor(newColor);
          }
        });
      };
  
      window.addEventListener("scroll", handle_Scroll);
      return () => {
        window.removeEventListener("scroll", handle_Scroll);
      };
    }, []);

  return (
    <>
      <Helmet>
        {/* ✅ Title */}
        <title>About Us</title>

        {/* ✅ Meta description — was completely missing */}
        <meta
          name="description"
          content="Learn about ExD Digital, our mission to deliver world-class AI, web and software development services, and the team behind our success."
        />

        {/* ✅ Canonical */}
        <link rel="canonical" href="https://www.exddigital.com/about-us" />

        {/* ✅ OG tags — were completely missing */}
        <meta property="og:title" content="About Us | ExD Digital" />
        <meta
          property="og:description"
          content="Learn about ExD Digital, our mission to deliver world-class AI, web and software development services, and the team behind our success."
        />
        <meta property="og:url" content="https://www.exddigital.com/about-us" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://www.exddigital.com/images/exd_digital.webp"
        />

        {/* ✅ Twitter tags — were completely missing */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="About Us | ExD Digital" />
        <meta
          name="twitter:description"
          content="Learn about ExD Digital, our mission to deliver world-class AI, web and software development services, and the team behind our success."
        />
        <meta
          name="twitter:image"
          content="https://www.exddigital.com/images/exd_digital.webp"
        />

        {/* ✅ Schema */}
        <script type="application/ld+json">
          {JSON.stringify(schemaMarkup)}
        </script>
      </Helmet>
      <main className="about-main">
        <article className="about-us">
          <Section1 url={devUrl} currentColor={currentColor}/>
          <Section2 url={devUrl} currentColor={currentColor}/>
          <Section3 url={devUrl} currentColor={currentColor}/>
          <Section4 url={devUrl} />

          <Section9 url={devUrl} />
        </article>
      </main>
    </>
  );
};
export default React.memo(AboutUs);
